import { CoordsDTO } from "../domain/models/dto/AddressDTO";

export class LocationServiceImpl {
    private static permissionDenied = false;

    static areValidCoords(coords: CoordsDTO): boolean {
        return (
            Number.isFinite(coords.latitude) &&
            coords.latitude >= -90 &&
            coords.latitude <= 90 &&
            Number.isFinite(coords.longitude) &&
            coords.longitude >= -180 &&
            coords.longitude <= 180
        );
    }

    static async getClientPosition(): Promise<CoordsDTO | undefined> {
        if (
            this.permissionDenied ||
            typeof navigator === "undefined" ||
            !navigator.geolocation
        ) {
            return undefined;
        }

        return new Promise((resolve) => {
            try {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const coords = {
                            longitude: position.coords.longitude,
                            latitude: position.coords.latitude,
                        };
                        resolve(this.areValidCoords(coords) ? coords : undefined);
                    },
                    (error) => {
                        if (error.code === 1) {
                            this.permissionDenied = true;
                        }
                        resolve(undefined);
                    },
                    { enableHighAccuracy: true, timeout: 10000 }
                );
            } catch {
                resolve(undefined);
            }
        });
    }
}
